export default __webpack_public_path__ + "static/media/guinea-pig-bg.5c81dab6.png";